export default "__VITE_ASSET__da3712d1__"